

// import React, { useEffect, useRef } from "react";
// import { Icon } from "@iconify/react";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

// export default function ContactSection() {
//   const sectionRef = useRef(null);
//   const imageRef = useRef(null);
//   const leftRef = useRef(null);
//   const rightRef = useRef(null);

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       // Fade-in entrance animations
//       gsap.from(leftRef.current, {
//         x: -80,
//         opacity: 0,
//         duration: 1.2,
//         ease: "power3.out",
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top 80%",
//         },
//       });

//       gsap.from(rightRef.current, {
//         x: 80,
//         opacity: 0,
//         duration: 1.2,
//         delay: 0.3,
//         ease: "power3.out",
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top 80%",
//         },
//       });

//       // Parallax image movement
//       gsap.to(imageRef.current, {
//         y: 150,
//         ease: "none",
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top bottom",
//           end: "bottom top",
//           scrub: true,
//         },
//       });

//       // Subtle floating up/down motion (looping)
//       gsap.to(imageRef.current, {
//         y: "+=20",
//         duration: 3,
//         ease: "sine.inOut",
//         yoyo: true,
//         repeat: -1,
//       });
//     }, sectionRef);

//     return () => ctx.revert();
//   }, []);

//   // Hover animation handlers
//   const handleHover = () => {
//     gsap.to(imageRef.current, {
//       rotate: 20,
//       scale: 1.05,
//       duration: 1,
//       ease: "power2.out",
//     });
//   };

//   const handleLeave = () => {
//     gsap.to(imageRef.current, {
//       rotate: 0,
//       scale: 1,
//       duration: 1,
//       ease: "power2.out",
//     });
//   };

//   return (
//     <section
//       ref={sectionRef}
//       className="relative bg-[#0b0b0b] text-white py-24 px-6 md:px-12 lg:px-24 overflow-hidden"
//     >
//       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center relative z-10">
//         {/* LEFT SIDE TEXT */}
//         <div ref={leftRef}>
//           <p className="text-[#ff3d00] uppercase tracking-[4px] text-sm font-semibold">
//             // Contact Us
//           </p>
//           <h2 className="text-4xl md:text-5xl font-extrabold leading-tight mt-3">
//             Feel Free To <br />
//             <span className="text-white/90">Ask</span> Us Anything
//           </h2>
//           <p className="text-gray-400 leading-relaxed mt-6 max-w-md">
//             Mouno provide <span className="text-white">best digital product design</span> 
//             for firms who are launching new products. We have best 3D artists 
//             here to serve best outputs.
//           </p>

//           {/* Soft background circle */}
//           <div className="absolute -left-20 top-1/3 w-72 h-72 bg-white/5 rounded-full blur-3xl hidden md:block" />
//         </div>

//         {/* RIGHT SIDE FORM */}
//         <div ref={rightRef} className="space-y-6">
//           <div className="grid md:grid-cols-2 gap-4">
//             <input
//               type="text"
//               placeholder="Your full name"
//               className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-full w-full outline-none focus:border-[#ff3d00] transition"
//             />
//             <input
//               type="email"
//               placeholder="E-mail address"
//               className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-full w-full outline-none focus:border-[#ff3d00] transition"
//             />
//           </div>

//           <input
//             type="text"
//             placeholder="Subject"
//             className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-full w-full outline-none focus:border-[#ff3d00] transition"
//           />

//           <textarea
//             placeholder="Message"
//             rows="5"
//             className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-3xl w-full outline-none resize-none focus:border-[#ff3d00] transition"
//           ></textarea>

//           <button className="flex items-center justify-between bg-transparent border border-white/30 hover:border-[#ff3d00] transition-all text-white px-6 py-3 rounded-full text-sm font-semibold group w-fit">
//             Send Message
//             <span className="ml-3 w-8 h-8 rounded-full bg-[#ff3d00] flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
//               <Icon icon="ic:round-arrow-forward" width="20" />
//             </span>
//           </button>
//         </div>
//       </div>

//       {/* MOVING + HOVERABLE BACKGROUND CROSS */}
//       <div
//         ref={imageRef}
//         onMouseEnter={handleHover}
//         onMouseLeave={handleLeave}
//         className="absolute right-0 top-1/2 -translate-y-1/2 w-[380px] md:w-[480px] lg:w-[550px] opacity-80 pointer-events-auto cursor-pointer"
//       >
//         <img
//           src="https://demo.casethemes.net/mouno/wp-content/uploads/2024/11/glossy-red-cross-1.png"
//           alt="Glossy Red Cross"
//           className="w-full h-auto object-contain"
//         />
//       </div>
//     </section>
//   );
// }



// import React, { useEffect, useRef } from "react";
// import { Icon } from "@iconify/react";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

// export default function ContactSection() {
//   const sectionRef = useRef(null);
//   const imageRef = useRef(null);
//   const leftRef = useRef(null);
//   const rightRef = useRef(null);

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       // Content entrance animation
//       gsap.from(leftRef.current, {
//         x: -80,
//         opacity: 0,
//         duration: 1.2,
//         ease: "power3.out",
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top 80%",
//         },
//       });

//       gsap.from(rightRef.current, {
//         x: 80,
//         opacity: 0,
//         duration: 1.2,
//         delay: 0.3,
//         ease: "power3.out",
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top 80%",
//         },
//       });

//       // Scroll-based parallax image movement
//       gsap.to(imageRef.current, {
//         y: 150,
//         ease: "none",
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top bottom",
//           end: "bottom top",
//           scrub: true,
//         },
//       });

//       // Subtle floating loop motion
//       gsap.to(imageRef.current, {
//         y: "+=20",
//         duration: 3,
//         ease: "sine.inOut",
//         yoyo: true,
//         repeat: -1,
//       });
//     }, sectionRef);

//     return () => ctx.revert();
//   }, []);

//   // Container hover animations
//   const handleEnter = () => {
//     gsap.to(imageRef.current, {
//       rotate: 20,
//       scale: 1.1,
//       filter: "drop-shadow(0px 0px 25px rgba(255,60,0,0.6))",
//       duration: 1,
//       ease: "power3.out",
//     });
//   };

//   const handleLeave = () => {
//     gsap.to(imageRef.current, {
//       rotate: 0,
//       scale: 1,
//       filter: "drop-shadow(0px 0px 0px rgba(255,60,0,0))",
//       duration: 1,
//       ease: "power3.out",
//     });
//   };

//   return (
//     <section
//       ref={sectionRef}
//       onMouseEnter={handleEnter}
//       onMouseLeave={handleLeave}
//       className="relative bg-[#0b0b0b] text-white py-24 px-6 md:px-12 lg:px-24 overflow-hidden cursor-pointer"
//     >
//       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center relative z-10">
//         {/* LEFT CONTENT */}
//         <div ref={leftRef}>
//           <p className="text-[#ff3d00] uppercase tracking-[4px] text-sm font-semibold">
//             // Contact Us
//           </p>
//           <h2 className="text-4xl md:text-5xl font-extrabold leading-tight mt-3">
//             Feel Free To <br />
//             <span className="text-white/90">Ask</span> Us Anything
//           </h2>
//           <p className="text-gray-400 leading-relaxed mt-6 max-w-md">
//             Mouno provide <span className="text-white">best digital product design</span> 
//             for firms who are launching new products. We have best 3D artists 
//             here to serve best outputs.
//           </p>
//         </div>

//         {/* RIGHT FORM */}
//         <div ref={rightRef} className="space-y-6">
//           <div className="grid md:grid-cols-2 gap-4">
//             <input
//               type="text"
//               placeholder="Your full name"
//               className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-full w-full outline-none focus:border-[#ff3d00] transition"
//             />
//             <input
//               type="email"
//               placeholder="E-mail address"
//               className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-full w-full outline-none focus:border-[#ff3d00] transition"
//             />
//           </div>

//           <input
//             type="text"
//             placeholder="Subject"
//             className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-full w-full outline-none focus:border-[#ff3d00] transition"
//           />

//           <textarea
//             placeholder="Message"
//             rows="5"
//             className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-3xl w-full outline-none resize-none focus:border-[#ff3d00] transition"
//           ></textarea>

//           <button className="flex items-center justify-between bg-transparent border border-white/30 hover:border-[#ff3d00] transition-all text-white px-6 py-3 rounded-full text-sm font-semibold group w-fit">
//             Send Message
//             <span className="ml-3 w-8 h-8 rounded-full bg-[#ff3d00] flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
//               <Icon icon="ic:round-arrow-forward" width="20" />
//             </span>
//           </button>
//         </div>
//       </div>

//       {/* ANIMATED CROSS IMAGE */}
//       <div
//         ref={imageRef}
//         className="absolute right-0 top-1/2 -translate-y-1/2 w-[380px] md:w-[480px] lg:w-[550px] opacity-80 pointer-events-none"
//       >
//         <img
//           src="https://demo.casethemes.net/mouno/wp-content/uploads/2024/11/glossy-red-cross-1.png"
//           alt="Glossy Red Cross"
//           className="w-full h-auto object-contain select-none"
//         />
//       </div>
//     </section>
//   );
// }


// import React, { useEffect, useRef } from "react";
// import { Icon } from "@iconify/react";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

// export default function ContactSection() {
//   const sectionRef = useRef(null);
//   const imageRef = useRef(null);
//   const leftRef = useRef(null);
//   const rightRef = useRef(null);

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       // Left + right fade-in
//       gsap.from(leftRef.current, {
//         x: -80,
//         opacity: 0,
//         duration: 1.2,
//         ease: "power3.out",
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top 80%",
//         },
//       });

//       gsap.from(rightRef.current, {
//         x: 80,
//         opacity: 0,
//         duration: 1.2,
//         delay: 0.3,
//         ease: "power3.out",
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top 80%",
//         },
//       });

//       // Scroll parallax for the cross image
//       gsap.to(imageRef.current, {
//         y: 150,
//         ease: "none",
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top bottom",
//           end: "bottom top",
//           scrub: true,
//         },
//       });

//       // Floating animation
//       gsap.to(imageRef.current, {
//         y: "+=20",
//         duration: 3,
//         ease: "sine.inOut",
//         yoyo: true,
//         repeat: -1,
//       });
//     }, sectionRef);

//     return () => ctx.revert();
//   }, []);

//   // Hover animation for entire section
//   const handleHover = () => {
//     gsap.to(imageRef.current, {
//       rotate: 20,
//       scale: 1.05,
//       duration: 1,
//       ease: "power2.out",
//       filter: "drop-shadow(0px 0px 30px rgba(255, 61, 0, 0.5))",
//     });
//   };

//   const handleLeave = () => {
//     gsap.to(imageRef.current, {
//       rotate: 0,
//       scale: 1,
//       duration: 1,
//       ease: "power2.out",
//       filter: "drop-shadow(0px 0px 0px rgba(255, 61, 0, 0))",
//     });
//   };

//   return (
//     <section
//       ref={sectionRef}
//       onMouseEnter={handleHover}
//       onMouseLeave={handleLeave}
//       className="relative bg-[#0b0b0b] text-white py-24 px-6 md:px-12 lg:px-24 overflow-hidden cursor-pointer"
//     >
//       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center relative z-10">
//         {/* LEFT CONTENT */}
//         <div ref={leftRef}>
//           <p className="text-[#ff3d00] uppercase tracking-[4px] text-sm font-semibold">
//             // Contact Us
//           </p>
//           <h2 className="text-4xl md:text-5xl font-extrabold leading-tight mt-3">
//             Feel Free To <br />
//             <span className="text-white/90">Ask</span> Us Anything
//           </h2>
//           <p className="text-gray-400 leading-relaxed mt-6 max-w-md">
//             Mouno provide <span className="text-white">best digital product design</span> 
//             for firms who are launching new products. We have best 3D artists 
//             here to serve best outputs.
//           </p>

//           {/* Glow circle */}
//           <div className="absolute -left-20 top-1/3 w-72 h-72 bg-white/5 rounded-full blur-3xl hidden md:block" />
//         </div>

//         {/* RIGHT FORM */}
//         <div ref={rightRef} className="space-y-6">
//           <div className="grid md:grid-cols-2 gap-4">
//             <input
//               type="text"
//               placeholder="Your full name"
//               className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-full w-full outline-none focus:border-[#ff3d00] transition"
//             />
//             <input
//               type="email"
//               placeholder="E-mail address"
//               className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-full w-full outline-none focus:border-[#ff3d00] transition"
//             />
//           </div>

//           <input
//             type="text"
//             placeholder="Subject"
//             className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-full w-full outline-none focus:border-[#ff3d00] transition"
//           />

//           <textarea
//             placeholder="Message"
//             rows="5"
//             className="bg-[#1a1a1a] border border-[#2a2a2a] text-white text-sm px-5 py-4 rounded-3xl w-full outline-none resize-none focus:border-[#ff3d00] transition"
//           ></textarea>

//           <button className="flex items-center justify-between bg-transparent border border-white/30 hover:border-[#ff3d00] transition-all text-white px-6 py-3 rounded-full text-sm font-semibold group w-fit">
//             Send Message
//             <span className="ml-3 w-8 h-8 rounded-full bg-[#ff3d00] flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
//               <Icon icon="ic:round-arrow-forward" width="20" />
//             </span>
//           </button>
//         </div>
//       </div>

//       {/* MOVING CROSS IMAGE */}
//       <div
//         ref={imageRef}
//         className="absolute right-0 top-1/2 -translate-y-1/2 w-[380px] md:w-[480px] lg:w-[550px] opacity-80 pointer-events-none"
//       >
//         <img
//           src="https://demo.casethemes.net/mouno/wp-content/uploads/2024/11/glossy-red-cross-1.png"
//           alt="Glossy Red Cross"
//           className="w-full h-auto object-contain"
//         />
//       </div>
//     </section>
//   );
// }


import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useState } from "react";

gsap.registerPlugin(ScrollTrigger);

export default function ContactSection() {
    const sectionRef = useRef(null);
    const imageRef = useRef(null);
    const leftRef = useRef(null);
    const rightRef = useRef(null);


    const [showPopup, setShowPopup] = useState(false);


    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");

    const contactUsContent = [
        {
            id: 1,
            icon: "mdi:contact",
            title: "Call Us",
            info: "+971 528805272",
        },
        {
            id: 2,
            icon: "mdi:email",
            title: "Email Us",
            info: "info@viskoit.ae",
        },
        
        {
            id: 3,
            icon: "mdi:open-in-new",
            title: "Open Hours",
            info: "Mon - Fri 9:00AM - 06:00PM",
        },
    ];


    // 📨 Handle Input Change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // 📨 Handle Submit (POST API)
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMessage("");
        setShowPopup(false);


        const payload = {
            li_subject: formData.subject,
            li_name: formData.name,
            li_email: formData.email,
            li_message: formData.message,
            li_company: "Visko HR Private Limted",
        };

        try {
            const res = await fetch(
                "https://api.visko.group/api/inquiry/message/insert-message",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (res.ok) {
                setResponseMessage("✅ Message sent successfully!");
                setFormData({ name: "", email: "", subject: "", message: "" });
            } else {
                setResponseMessage("❌ Failed to send message. Try again.");
            }
        } catch (error) {
            console.error(error);
            setResponseMessage("⚠️ Network error. Please try later.");
        } finally {
            setLoading(false);
            setShowPopup(true);
            setTimeout(() => setShowPopup(false), 3000);
        }
    };



    useEffect(() => {
        const ctx = gsap.context(() => {
            // Fade-in animation for text and form
            gsap.from(leftRef.current, {
                x: -80,
                opacity: 0,
                duration: 1.2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%",
                },
            });

            gsap.from(rightRef.current, {
                x: 80,
                opacity: 0,
                duration: 1.2,
                delay: 0.3,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%",
                },
            });

            // Scroll-based parallax movement
            gsap.to(imageRef.current, {
                y: 150,
                ease: "none",
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                },
            });

            // Floating loop movement
            gsap.to(imageRef.current, {
                y: "+=20",
                duration: 3,
                ease: "sine.inOut",
                yoyo: true,
                repeat: -1,
            });
        }, sectionRef);

        return () => ctx.revert();
    }, []);

    // Hover animation (for entire section)
    const handleHover = () => {
        gsap.to(imageRef.current, {
            rotate: 20,
            scale: 1.05,
            filter: "drop-shadow(0px 0px 20px rgba(255,61,0,0.6))",
            duration: 1,
            ease: "power2.out",
        });
    };

    const handleLeave = () => {
        gsap.to(imageRef.current, {
            rotate: 0,
            scale: 1,
            filter: "drop-shadow(0px 0px 0px rgba(255,61,0,0))",
            duration: 1,
            ease: "power2.out",
        });
    };

    return (
        <section
            ref={sectionRef}
            onMouseEnter={handleHover}
            onMouseLeave={handleLeave}
            className="relative bg-[#0b0b0b] text-white py-24 px-6 md:px-12 lg:px-24 overflow-hidden cursor-pointer"
        >

            <div className="w-full mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-start relative z-10">
                {/* POPUP MESSAGE */}
                {showPopup && (
                    <div
                        className={`fixed bottom-8 right-6 z-[9999] px-6 py-3 rounded-lg shadow-lg text-sm font-medium transition-all duration-500 ${responseMessage.includes("✅")
                            ? "bg-green-600 text-white"
                            : responseMessage.includes("⚠️")
                                ? "bg-yellow-600 text-white"
                                : "bg-red-600 text-white"
                            } animate-slide-in`}
                    >
                        {responseMessage}
                    </div>
                )}
                {/* LEFT SECTION */}
                <div ref={leftRef} className="space-y-8">
                    <button className="bg-white/10 border border-white/20 px-5 py-2 rounded-full text-sm mb-6 hover:bg-white/20 transition-all flex">
                        <Icon
                            icon="material-symbols:lightbulb-2-rounded"
                            className="mr-1.5 text-[#F26A33] drop-shadow-[0_0_6px_#F26A33]"
                            width="22"
                            height="20"
                        />
                        CONTACT US
                    </button>

                    {/* Heading */}
                    <h2 className="animate-text text-4xl lg:text-4xl xl:text-7xl font-light text-gray-400 mb-4 leading-tight">
                        Get in Touch {" "}
                        <span className="text-white font-light">with Our Team!</span>
                    </h2>

                    {/* Service Cards */}
                    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 pt-4">
                        {contactUsContent.map((service) => (
                            <div
                                key={service.id}
                                className="bg-neutral-900 md:p-6 p-3 rounded-2xl border border-neutral-800 hover:border-orange-500 hover:scale-105 transition-all duration-300 group"
                            >
                                <div className="text-orange-500 mb-3">
                                    <Icon icon={service.icon} width="36" height="36" />
                                </div>
                                <h3 className="text-lg font-medium leading-snug group-hover:text-white transition-colors">
                                    {service.title}
                                </h3>
                                <p className="text-[#99A1AF] text-xs sm:text-base font-medium leading-relaxed pt-2 break-words">
                                    {service.info}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* RIGHT FORM SECTION */}
                <div ref={rightRef} >
                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Your full name"
                                required
                                className="bg-[#1c1c1c]/60 border border-orange-900 w-full px-5 py-4 rounded-2xl outline-none focus:ring-2 focus:ring-[#F26A33] transition-all text-sm sm:text-base"
                            />
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="E-mail address"
                                required
                                className="bg-[#1c1c1c]/60 border border-orange-900 w-full px-5 py-4 rounded-2xl outline-none focus:ring-2 focus:ring-[#F26A33] transition-all text-sm sm:text-base"
                            />
                        </div>

                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            placeholder="Subject"
                            required
                            className="bg-[#1c1c1c]/60 border border-orange-900 w-full px-5 py-4 rounded-2xl outline-none focus:ring-2 focus:ring-[#F26A33] transition-all text-sm sm:text-base"
                        />

                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Message"
                            rows="5"
                            required
                            className="bg-[#1c1c1c]/60 border border-orange-900 w-full px-5 py-4 rounded-2xl outline-none resize-none focus:ring-2 focus:ring-[#F26A33] transition-all text-sm sm:text-base"
                        />

                        {/* Send Button */}
                        <button type="submit"
                            disabled={loading} className={`${loading ? "bg-gray-600" : "bg-[#F26A33] hover:bg-orange-600"
                                } relative inline-flex items-center justify-center px-10 py-3 overflow-hidden tracking-tighter text-white bg-orange-600 rounded-md group`} >
                            <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-gray-600 rounded-full group-hover:w-56 group-hover:h-56"></span>
                            <span className="absolute bottom-0 left-0 h-full -ml-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-auto h-full opacity-100 object-stretch" viewBox="0 0 487 487" >
                                    <path
                                        fill-opacity=".1"
                                        fill-rule="nonzero"
                                        fill="#FFF"
                                        d="M0 .3c67 2.1 134.1 4.3 186.3 37 52.2 32.7 89.6 95.8 112.8 150.6 23.2 54.8 32.3 101.4 61.2 149.9 28.9 48.4 77.7 98.8 126.4 149.2H0V.3z"
                                    ></path>
                                </svg>
                            </span>
                            <span className="absolute top-0 right-0 w-12 h-full -mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="object-cover w-full h-full" viewBox="0 0 487 487" >
                                    <path
                                        fill-opacity=".1"
                                        fill-rule="nonzero"
                                        fill="#FFF"
                                        d="M487 486.7c-66.1-3.6-132.3-7.3-186.3-37s-95.9-85.3-126.2-137.2c-30.4-51.8-49.3-99.9-76.5-151.4C70.9 109.6 35.6 54.8.3 0H487v486.7z"
                                    ></path>
                                </svg>
                            </span>
                            <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-gray-200"></span>
                            <span className="relative text-base font-semibold">Submit</span>
                        </button>

                        {/* {responseMessage && (
                                  <p className="pt-2 text-sm text-center text-gray-300">
                                      {responseMessage}
                                  </p>
                              )} */}
                    </form>
                </div>

            </div>

            {/* CROSS IMAGE */}
            <div
                ref={imageRef}
                className="absolute right-0 top-1/2 -translate-y-1/2 w-[380px] md:w-[480px] lg:w-[550px] opacity-90 pointer-events-none"
            >
                <img
                    // src={require("../assets/contact-us2.png")} 
                    src="https://api.visko.group/public/assets/img/uploads/gallery/Chakra Visko.webp"
                    alt="Glossy Red Cross"
                    className="w-full h-auto object-contain select-none"
                />
            </div>
        </section>
    );
}
